import axios from "axios";
import { mainUrl, ossUrl } from '../config/env'
import router from "./../router";
import Vue from 'vue'
Vue.prototype.$http = axios.create({})
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=utf-8";


axios.interceptors.request.use(function(config) {
  // 在发送请求之前做些什么
  let channelId = sessionStorage.getItem("channelId");
  let adminAccount = sessionStorage.getItem("adminAccount");
  let allSessionId = sessionStorage.getItem("allSessionId");
  let permissionId = sessionStorage.getItem("permissionId");
  // if (!channelId || !adminAccount || !allSessionId || !permissionId) {
  //   location.href = localStorage.getItem('channelChannelUrl') ? localStorage.getItem('channelChannelUrl') : localStorage.getItem('channelUrl');
  // }
  config.headers["channelId"] = channelId;
  config.headers["adminAccount"] = adminAccount;
  config.headers["allSessionId"] = allSessionId;
  config.headers["permissionId"] = permissionId;
  return config;
}, function(error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

let isOk = true;
axios.interceptors.response.use(function(response) {
  // token 已过期，重定向到登录页面
  if (response.data.code == 2) {
    if (isOk) {
      isOk = false;
      // alert('登录超时，请重新登录！');
      router.replace({ path: "/login" });
      sessionStorage.clear();
      localStorage.clear();
      setTimeout(() => {
        isOk = true;
      }, 2000);
    }
  }
  return response;
}, function(error) {
  // Do something with response error
  return Promise.reject(error);
});

/**
 * 字符串拼接
 * @param info 要拼接的对象
 * @param type 是否是需要？拼接
 */
let stringJoin;
stringJoin = (info, type) => {
  let headerString = '';
  if (!info) {
    return '';
  }
  Object.keys(info).map((data, index) => {
    if (index === 0 && type === 2) {
      headerString += data + "=" + info[data];
    } else if (index === 0 && type) {
      headerString += "?" + data + "=" + info[data];
    } else {
      headerString += "&" + data + "=" + info[data];
    }
  });
  return headerString
};
let searchParams = (prop) => {
  let param = new URLSearchParams();
  for (let key in prop) {
    param.append(key, prop[key]);
  }
  return param;
};
//手机端
let transformRequest = (data) => {
  let ret = "";
  for (let it in data) {
    ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
  }
  return ret;
};



/**
 * 首页和园区通知管理列表接口
 * pageIndex  否  int  页码
 * pageSize  否  int  每页显示数量
 * notifyName  否  String  通知名称
 * isRead  否  int  0未读1已读
 */
let listNotify = (pageIndex, pageSize, notifyName, isRead) => axios.get("/company/notify/listNotify?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&notifyName=" + notifyName + "&isRead=" + isRead);

/**
 * 查看通知详情接口
 * notifyId  是  long  通知主键
 */
let findNotify = (notifyId) => axios.get("/company/notify/findNotify?notifyId=" + notifyId);

/**
 * 用户获取信息
 *
 */
let getInfo = () => axios.get("/company/mhManager/getInfo");

/**
 * 用户修改密码
 * userId  Y  String  用户ID
 * oldPassword  Y  String  旧密码
 * newPassword  Y  String  新密码
 * newRepeatPassword  Y  String  重复新密码
 */
let changePassword = (data) => axios.post("/company/user/changePassword", JSON.stringify(data), { headers: { "Content-Type": "application/json" } });

/**
 * 资料模版列表
 * pageIndex  Y  int  页码
 * pageSize  Y  int  页面显示条数
 * resourceName  N  String  文件名称
 */
let resourceList = (pageIndex, pageSize, resourceName) => axios.get("/company/resource/resourceList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&resourceName=" + resourceName);

/**
 * 企业端-事项列表接口
 * pageIndex  N  Integer
 * pageSize  N  Integer
 * matterName  N  string  事项名称
 * matterTypeId  N  Integer  事项类型 1.默认
 * matterCompanyStatus  N  Integer  0未处理(未提交)1被驳回(驳回待提交)2已处理(待确认)3完成
 */
let listMatterCompany = (pageIndex, pageSize, matterName, matterTypeId, matterCompanyStatus) => axios.get("/company/matterCompany/listMatterCompany?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&matterName=" + matterName + "&matterTypeId=" + matterTypeId + "&matterCompanyStatus=" + matterCompanyStatus);

/**
 * 未处理事项详情
 参数名  必选  类型  说明
 matterCompanyId  是  long  事项id
 */
let matterCompanyDetail = (matterCompanyId) => axios.get("company/matterCompany/matterCompanyDetail", { params: { matterCompanyId: matterCompanyId } });

/**
 * 企业端-事项详情
 * matterId  Y  Long  事项id
 */
let findMatterById = (matterId) => axios.get("/company/matter/findMatterById?matterId=" + matterId);

/**
 * 获取所有事项类别列表
 */
let getAllType = () => axios.get("company/matterType/getAllType");

/**
 * 事项管理-处理事项
 */
let handleMatterCompany = (data) => axios.post("company/matterCompany/handleMatterCompany", JSON.stringify(data), { headers: { "Content-Type": "application/json" } });

/**
 * 事项编辑接口
 */
let editMatterCompany = (data) => axios.post("company/matterCompany/editMatterCompany", JSON.stringify(data), { headers: { "Content-Type": "application/json" } });

/**
 * 已填报事项详情接口
 参数名  必选  类型  说明
 matterCompanyId  是  long  企业与事项关联id
 */
let matterCompanyDetailDetail = (matterCompanyId) => axios.get("company/matterCompany/matterCompanyDetailDetail", { params: { matterCompanyId: matterCompanyId } });

/**
 * 企业端-新增关联文件
 * matterCompanyFileName  string  文件名
 * matterCompanyFileUrl  string  文件url
 * matterCompanyFileMatterCompanyId  Long  对应关联id
 */
let addMatterCompanyFile = (data) => axios.post("/company/matterCompanyFile/addMatterCompanyFile", JSON.stringify(data), { headers: { "Content-Type": "application/json" } });

/**
 * 企业端-关联文件列表
 * matterCompanyId  Y  Long  关联Id
 */
let listFilesByMatterCompanyId = (matterCompanyId) => axios.get("/company/matterCompanyFile/listFilesByMatterCompanyId?matterCompanyId=" + matterCompanyId);

/**
 * 企业端-删除关联文件
 * fileId  Y  Long  关联文件id
 */
let deleteMatterCompanyFile = (fileId) => axios.post("/company/matterCompanyFile/deleteMatterCompanyFile", `fileId=${fileId}`);

/**
 * 企业端首页
 */
let indexDate = () => axios.get("/company/index/indexDate");

/**
 * 用户登录
 * phone	是	string	手机号
 * phoneCode	是	string	验证码
 */
let login = (data) => axios.post("/company/mhManager/login",  stringJoin(data, 2));

/**
 * 用户登录
 * phone	是	string	手机号
 * type	是	integer	1 修改手机号 2 登录
 */
const sendCodeMsg = (params) => axios.get("/company/mhManager/sendCode", { params: params });

/**
 * 用户登出
 */
let logout = (allSessionId) => axios.post("/company/mhManager/logout", `allSessionId=${allSessionId}`);

/**
 * 核对是否登录
 */
let checkLogin = () => axios.get("/company/mhManager/checkLogin");

/**
 * 发送验证码
 */
let sendCode = (phone, codeState) => axios.get("/company/mhManager/sendCode?phone=" + phone + "&codeState=" + codeState);

/**
 * 修改手机号
 */
let changeMoblie = (mobile, code) => axios.post("/company/mhManager/changeMoblie", `mobile=${mobile}&code=${code}`);

/**
 *
 */
let getChannelIdByUrl = (url) => axios.get(`${mainUrl}back/channel/getChannelIdByUrl?url=${url}`);


/**
 * 新增申请工作流列表
 pageIndex  页码
 pageSize  页面
 */

const workflowList = (pageIndex, pageSize) => axios.get(`/company/workflow/workflowList?pageIndex=${pageIndex}&pageSize=${pageSize}`);

/**
 * 新增申请流程详情
 workflowId  工作流ID
 */

const getWorkflow = (workflowId) => axios.get(`/company/workflow/getWorkflow?workflowId=${workflowId}`);

/**
 * 新增工作流申请

 参数名  必选  类型  说明
 workflowId  是  Long  工作流ID
 workflowApplicationTitle  是  string  标题
 workflowApplicationDes  是  string  描述
 files: {workflowApplicationFileUrl: workflowApplicationFileUrl, workflowApplicationFileName: workflowApplicationFileName}
 workflowApplicationFileUrl  否  string  文件地址
 workflowApplicationFileName  否  string  文件名
 */
const addWorkflowApplication = (data) => axios.post("/company/workflowApplication/addWorkflowApplication", JSON.stringify(data), { headers: { "Content-Type": "application/json" } });


/**
 * 我的申请列表
 参数名  必选  类型  说明
 pageIndex  是  Integer  页码
 pageSize  是  Integer  页面
 workflowApplicationStatus  是  Integer  -1全部0审批中1完成2驳回3关闭
 */

const myWorkflowApplicationList = (pageIndex, pageSize, status) => axios.get(`/company/workflowApplication/myWorkflowApplicationList?pageIndex=${pageIndex}&pageSize=${pageSize}&status=${status}`);

/**
 * 撤回工作流
 参数名  必选  类型  说明
 workflowApplicationId  是  Long  工作流主键
 */

const revocationWorkflowApplication = (workflowApplicationId) => axios.post("/company/workflowApplication/revocationWorkflowApplication", `workflowApplicationId=${workflowApplicationId}`);

/**
 * 审批详情
 参数名  必选  类型  说明
 workflowApplicationId  是  Long  工作流ID
 */

const getWorkflowApplication = (workflowApplicationId) => axios.get(`/company/workflowApplication/getWorkflowApplication?workflowApplicationId=${workflowApplicationId}`);

/**
 * 合同提醒列表接口
 参数名  必选  类型  说明
 companyId  是  int  公司id
 type  是  int  合同类型
 pageIndex  是  int  当前页面
 pageSize  是  int  页面大小
 */

const companyContractReminds = (companyId, type, pageIndex, pageSize) => axios.get(`/company/contractRemind/companyContractReminds?companyId=${companyId}&type=${type}&pageIndex=${pageIndex}&pageSize=${pageSize}`);

/**
 * 账单提醒列表接口
 参数名  必选  类型  说明
 companyId  是  int  公司id
 contractNumber  是  string  合同编号
 pageIndex  是  int  当前页面
 pageSize  是  int  页面大小
 */

const companyBillList = (companyId, contractNumber, pageIndex, pageSize) => axios.get(`/company/contractRemind/companyBillList?companyId=${companyId}&contractNumber=${contractNumber}&pageIndex=${pageIndex}&pageSize=${pageSize}`);

/**
 * 消息列表
 参数名  必选  类型  说明
 pageIndex  是  Integer  页码
 pageSize  是  Integer  页面
 readStatus  是  Integer  -1全部0未读1已读
 */

const messageList = (pageIndex, pageSize, readStatus) => axios.get(`/company/message/messageList?pageIndex=${pageIndex}&pageSize=${pageSize}&readStatus=${readStatus}`);

/**
 * 删除消息
 参数名  必选  类型  说明
 messageId  是  Long  消息主键
 */
const deleteMessage = (messageId) => axios.post("/company/message/deleteMessage", `messageId=${messageId}`);

/**
 * 消息详情
 参数名  必选  类型  说明
 messageId  是  Long  消息主键
 */

const getMessage = (messageId) => axios.get(`/company/message/getMessage?messageId=${messageId}`);

/**
 * 移动端人员管理 用户列表接口
 参数名  必选  类型  说明
 pageIndex  是  int  页码
 pageSize  是  string  每页显示条数
 confirmState  是  int  审核状态 (1未认证2认证中3认证通过 4认证驳回 -1:认证中,认证通过)
 moblie  是  string  手机号码
 companyId  是  Long  公司id
 userName  是  string  用户名
 */

const mhUserList = (pageIndex, pageSize, confirmState, moblie, userName) => axios.get(`/company/user/mhUserList?pageIndex=${pageIndex}&pageSize=${pageSize}&confirmState=${confirmState}&moblie=${moblie}&userName=${userName}`);

/**
 * 移动端人员管理 用户新增接口
 * json
 参数名  必选  类型  说明
 userMobile  是  string  用户手机号码
 userName  是  string  用户姓名
 userPostionState  是  int  公司职务状态 1企业员工2企业管理员
 */

const addMhUser = (data) => axios.post("/company/user/addMhUser", JSON.stringify(data), { headers: { "Content-Type": "application/json" } });

/**
 * 移动端人员管理 用户审批通过接口
 请求URL：

 http://192.168.0.164:8080/company/user/passMhUser
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 userId  是  Long  用户id
 userPostionState  是  int  用户职务状态 0未填写1企业员工2企业管理员3园区工作人员 4园区管理员
 userMobile 是 用户手机号
 userName   是 用户名
 */

const passMhUser = (userId, userPostionState, userMobile, userName,userNumber) => axios.get(`/company/user/passMhUser?userId=${userId}&userPostionState=${userPostionState}&userMobile=${userMobile}&userName=${userName}&userNumber=${userNumber}`);

/*
移动端人员管理 已通过用户删除接口
company/user/rebackUser?userId=1
*/

const deleteUser = (userId) => axios.get(`/company/user/rebackUser?userId=${userId}`);

/**
 * 移动端人员管理 用户审批不通过接口
 请求URL：

 http://xx.com/company/user/noPassMhUser
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 userId  是  Long  用户id
 */

const noPassMhUser = (userId) => axios.get(`/company/user/noPassMhUser?userId=${userId}`);


/**
 * 角色权限管理 角色列表接口
 参数名  必选  类型  说明
 pageIndex  是  int  页码
 pageSize  是  string  每页显示条数
 mhRoleId  否  Long  角色id
 */

const mhRoleList = (pageIndex, pageSize, mhRoleId) => axios.get(`/company/mhRole/mhRoleList?pageIndex=${pageIndex}&pageSize=${pageSize}&mhRoleId=${mhRoleId}`);

/**
 * 角色权限管理 获取权限树接口
 */

const getPermissions = () => axios.get(`/company/mhPermission/getPermissions`);

/**
 * 角色权限管理 新建角色接口
 参数名  必选  类型  说明
 mhRoleName  是  string  角色名
 mhRoleDescription  是  string  角色描述
 mhRoleCompanyId  是  Long  公司id
 mhRoleChannelId  是  Long  渠道id
 tpermissions  是  list  权限列表
 mhRoleAdminId  是  Long  当前管理员id
 */

const addMhRole = (mhRoleName, mhRoleDescription, tpermissions) => axios.post("/company/mhRole/addMhRole", `mhRoleName=${mhRoleName}&mhRoleDescription=${mhRoleDescription}&tpermissions=${tpermissions}`);

/**
 * 角色权限管理 角色删除接口
 参数名  必选  类型  说明
 mhRoleId  是  Long  角色id
 */

const deleteMhRole = (mhRoleId) => axios.get(`/company/mhRole/deleteMhRole?mhRoleId=${mhRoleId}`);

/**
 * 角色权限管理 角色更新接口
 参数名  必选  类型  说明
 mhRoleId  是  Long  角色id
 mhRoleName  是  string  角色名
 mhRoleDescription  是  string  角色描述
 mhRoleCompanyId  是  Long  公司id
 mhRoleChannelId  是  Long  渠道id
 tpermissions  是  list  权限列表
 mhRoleAdminId  是  Long  当前管理员id
 */

const updateMhRole = (mhRoleId, mhRoleName, mhRoleDescription, tpermissions) => axios.post("/company/mhRole/updateMhRole", `mhRoleId=${mhRoleId}&mhRoleName=${mhRoleName}&mhRoleDescription=${mhRoleDescription}&tpermissions=${tpermissions}`);

/**
 * 角色权限管理 角色详情接口
 参数名  必选  类型  说明
 mhRoleId  是  Long  角色id
 */

const findMhRole = (mhRoleId) => axios.get(`/company/mhRole/findMhRole?mhRoleId=${mhRoleId}`);


/**
 * 系统管理 系统管理员列表接口
 参数名  必选  类型  说明
 pageIndex  是  string  页码
 pageSize  是  string  每页显示条数
 moblie  否  string  手机号码
 name  否  string  名称
 mhManagerId  是  Long  管理员主键
 */

const mhManagerList = (pageIndex, pageSize, moblie, name) => axios.get(`/company/mhManager/mhManagerList?pageIndex=${pageIndex}&pageSize=${pageSize}&moblie=${moblie}&name=${name}`);

/**
 * 系统管理 新增管理员接口
 请求URL：

 http://192.168.0.164:8080/company/mhManager/addMhManager
 请求方式：

 JSON形式传递
 参数：

 参数名  必选  类型  说明
 mhManagerName  是  string  用户名
 password       是 string 密码
 mhManagerMobile  是  string  手机号码
 mhManagerAccount  否  string  账号
 mhRoleIds  是  List  角色
 */

const addMhManager = (mhManagerName, password, mhManagerMobile, mhManagerAccount, mhRoleIds) => axios.post("/company/mhManager/addMhManager", `mhManagerName=${mhManagerName}&password=${password}&mhManagerMobile=${mhManagerMobile}&mhManagerAccount=${mhManagerAccount}&mhRoleIds=${mhRoleIds}`);

/**
 * 系统管理 管理员更新接口

 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员主键
 mhManagerName  是  string  管理员名称
 mhManagerMobile  否  string  手机号码
 mhManagerAccount  是  string  账号
 mhRoleIds  是  list  角色id列表
 mhManagerChannelId  是  Long  渠道id
 mhManagerCompanyId  是  Long  公司id
 mhManagerCreateId  是  Long  当前管理员id
 */
const updateMhManager = (mhManagerId, mhManagerName, mhManagerMobile, mhManagerAccount, mhRoleIds) => axios.post("/company/mhManager/updateMhManager", `mhManagerId=${mhManagerId}&mhManagerName=${mhManagerName}&mhManagerMobile=${mhManagerMobile}&mhManagerAccount=${mhManagerAccount}&mhRoleIds=${mhRoleIds}`);

/**
 * 系统管理 删除管理员接口
 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 */

const deleteMhManager = (mhManagerId) => axios.get(`/company/mhManager/deleteMhManager?mhManagerId=${mhManagerId}`);

/**
 * 系统管理 管理员重置密码接口
 请求URL：

 http://192.168.0.164:8080/company/mhManager/reSetPassword
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 */

const reSetPassword = (mhManagerId) => axios.get(`/company/mhManager/reSetPassword?mhManagerId=${mhManagerId}`);

/**
 * 系统管理 管理员详情接口
 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 */

const getManagerInfo = (mhManagerId) => axios.get(`/company/mhManager/getManagerInfo?mhManagerId=${mhManagerId}`);

/**
 * 系统管理 管理员修改密码接口
 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 currPassword  是  string  当前密码
 newPassword  是  string  新密码
 */

const managerChangePassword = (mhManagerId, currPassword, newPassword) => axios.post("/company/mhManager/changePassword", `mhManagerId=${mhManagerId}&currPassword=${currPassword}&newPassword=${newPassword}`);

/**
 * 系统管理 下拉框选项获取角色列表
 */

const selectRoleList = () => axios.get(`/company/mhRole/getAllMhRole`);

/**
 * 系统管理 发送验证码接口
 参数名  必选  类型  说明
 phone  是  string  管理员手机号
 codeState  是  int  传递0
 mhManagerId  是  long  当前管理员id
 */

const managerSendCode = (phone, codeState, mhManagerId) => axios.get(`/company/mhManager/sendCode?phone=${phone}&codeState=${codeState}&mhManagerId=${mhManagerId}`);

/**
 * 系统管理 管理员修改手机号接口
 请求URL：

 http://192.168.0.164:8080/company/mhManager/changeMoblie
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 mobile  是  string  手机号
 code  是  string  验证码
 mhManagerId  是  Long  当前管理员id
 */

const managerChangeMoblie = (mobile, code, mhManagerId) => axios.post("/company/mhManager/changeMoblie", `mobile=${mobile}&code=${code}&mhManagerId=${mhManagerId}`);

/**
 * 系统管理 根据管理员id列表返回对应的管理员详情接口
 请求URL：

 http://192.168.0.164:8080/manager/mhManager/getManagerByIds
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 ids  是  list  管理员id列表
 */

const getManagerByIds = (ids) => axios.post("/manager/mhManager/getManagerByIds", `ids=${ids}`);

/**
 * 系统管理 统计提醒消息未读数
 */

const remindsCount = () => axios.get(`/company/contractRemind/remindsCount`);

/** 获取服务对接列表接口
 参数名  必选  类型  说明
 pageIndex  是  Integer  当前页数
 pageSize  是  Integer  显示条数
 serveType  是  String  服务类别
 */
let serveList = (params) => axios.get("company/serve/list", { params: params });

/**
 * 服务详情接口
 参数名  必选  类型  说明
 serveId  是  long  服务主键
 */
let serveDetail = (serveId) => axios.get("company/serve/serveDetail", { params: { serveId: serveId } });


/**
 *  问题反馈列表接口
 参数名  必选  类型  说明
 pageIndex  是  int  页码
 pageSize  是  int  显示条数
 type  否  int  类型 1 水电维修 2 卫生保洁 3 设施维修 4 绿化保养 5 其他
 state  否  int  状态（1未处理，2已处理）
 */
let feedbackList = (params) => axios.get("company/feedback/findCompanyFeedbackByCondition", { params: params });

/**
 *  问题反馈新增接口
 参数名  必选  类型  说明
 feedType  是  int  类型 1 水电维修 2 卫生保洁 3 设施维修 4 绿化保养 5 其他
 feedTitle  是  string  问题标题
 feedContent  是  string  反馈内容
 backFiles  否  List  文件路径列表,如1.jpg(请求上传接口获取地址)
 */
let addFeedback = (feedType, feedTitle, feedContent, backFiles) => axios.post("company/feedback/addFeedback", `feedType=${feedType}&feedTitle=${feedTitle}&feedContent=${feedContent}&backFiles=${backFiles}`);

/**
 *  问题反馈新增接口
 参数名  必选  类型  说明
 feedId  是  long  问题反馈主键
 */
let feedbackDetail = (feedId) => axios.get("company/feedback/feedbackDetail", { params: { feedId: feedId } });

/**
 *  问题反馈删除接口
 参数名  必选  类型  说明
 feedId  是  long  问题反馈主键
 */
let feedbackDelete = (feedId) => axios.post("company/feedback/deleteFeedback", `feedId=${feedId}`);

let changeManagerPassword = (currPassword, newPassword) => axios.post("/company/mhManager/changePassword", `currPassword=${currPassword}&newPassword=${newPassword}`);


/*
访客详情
用户注册接口
visitorId	是	long	访客ID
http://192.168.0.135:7777/company/visitor/getVisitor
*/
const getVisitor = (visitorId) => axios.get(`/company/visitor/getVisitor?visitorId=${visitorId}`);


/*
访客管理列表
参数名	必选	类型	说明
pageIndex	是	Integer	页码
pageSize	是	Integer	页面
visitorName	否	String	来访联系人
visitorVisitType	否	Integer	拜访备注0全部;1面试;2商业洽谈;3参观学习;4企业拜访;5领导来访;6其他
visitorState	否	Integer	状态 0全部;1未过期;2已过期
*/
const visitorList = (pageIndex, pageSize, visitorName, visitorVisitType, visitorState) => axios.get(`/company/visitor/visitorList?pageIndex=${pageIndex}&pageSize=${pageSize}&visitorName=${visitorName}&visitorVisitType=${visitorVisitType}&visitorState=${visitorState}`);
/*
导出访客管理列表
参数名	必选	类型	说明
visitorName	否	String	来访联系人
visitorVisitType	否	Integer	拜访备注0全部;1面试;2商业洽谈;3参观学习;4企业拜访;5领导来访;6其他
visitorState	否	Integer	状态 0全部;1未过期;2已过期
*/
const exportVisitorList = (visitorName, visitorVisitType, visitorState) => axios.get(`/company/visitor/exportVisitorList?visitorName=${visitorName}&visitorVisitType=${visitorVisitType}&visitorState=${visitorState}`);


/**
 * 快捷入口列表
 */
let findEntranceByChannel = () => axios.get('company/entrance/findEntranceByChannel');

//人脸

/**
 * 人脸列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * personNumber	否	Integer	员工账号
 * endTime	否	Date	录入结束时间
 * startTime	否	Date	录入开始时间
 */
let faceList = (pageIndex,pageSize,personNumber,startTime,endTime) => axios.get(`company/userFace/faceList?pageIndex=${pageIndex}&pageSize=${pageSize}&personNumber=${personNumber}&startTime=${startTime}&endTime=${endTime}`);

/**
 * 获取企业不分页员工列表接口
 * moblie	否	string	手机号
 * userName	否	string	用户名
 */
let passMhUserList = (moblie,userName) => axios.get(`company/userFace/passMhUserList?moblie=${moblie}&userName=${userName}`);

/**
 * 人脸新增接口
 */
let companyAddFace = (data) => axios.post(`company/userFace/companyAddFace`, JSON.stringify(data), {headers: { "Content-Type": "application/json" }});

/**
 * 查看人脸详情接口
 * faceId	是	Long	人脸主键id
 */
let detailFace = (faceId) => axios.get(`company/userFace/detailFace?faceId=${faceId}`);

/**
 * 人脸修改记录接口
 * faceId	是	Long	人脸主键id
 */
let faceRecordList = (faceId) => axios.get(`company/userFace/faceRecordList?faceId=${faceId}`);

/**
 * 批量删除人脸接口
 * personIds 是 [] 人脸主键id数组
 */
let delPerson = (personIds) => axios.post(`company/userFace/delPerson`, `personIds=${personIds}`);

/**
 * 通行记录
 * companyId 是 Long 企业id
 * type 否 Long 人员类型(1/企业员工 2/园区员工 3/访客)
 * nameOrNumber 否 String 人员姓名或账号
 * buildId 否 Long 楼宇id
 * time 否 String 筛选时间年月日 yyyy-MM-dd
 * pageIndex 否 int 当前页
 * pageSize 否 int 每页数据量
 */
// let getPersonPassList = (pageIndex,pageSize,nameOrNumber,time,companyId,type,buildId) => axios.get(`company/userFace/getPersonPassList?pageIndex=${pageIndex}&pageSize=${pageSize}&companyId=${companyId}&type=${type}&nameOrNumber=${nameOrNumber}&buildId=${buildId}&time=${time}`);
let getPersonPassList = (params) => axios.get(`company/userFace/getPersonPassList`, {params: params});

/**
 * 获取sso信息接口
 * url	是	string	当前服务域名
 */
let systemOssByUrl = (url) => axios.get(`company/userFace/systemOssByUrl?url=${url}`, ``);

const updateMhUserRole = (data) => axios.post(`/company/user/updateMhUserRole`, stringJoin(data,2));


/**
 * 确认通知接口
 */
let readConfirm = (data) => axios.post(`company/notify/readConfirm`, JSON.stringify(data), {headers: { "Content-Type": "application/json" }});

// 疫情

/**
 * 公司名称列表接口
 */
// let getCompanyNameList = () => axios.get('garden/orderDepartment/getCompanyNameList');

/**
 * 企业端列表
 参数名	必选	类型	说明
name	否	string	用户名
time	否	Date	登记时间
reworkTime	否	Date	反园时间
pageIndex	否	int	当前页数
pageSize	否	int	每页数量
 */
let erList = (data) => axios.get('company/er/list', {params: data});

/**
 * 企业端详情
 参数名	必选	类型	说明
id	是	Long	主键id
 */
let vrDetail = (id) => axios.get('company/er/detail?id=' + id);

/**
 * 园区端删除防疫登记
 * 参数名	必选	类型	说明
vrId	是	int	主键ID
 */
let deleteVR = (data) => axios.get('company/er/delete', { params: data });


/**
 * 园区端新增防疫登记
 */
let addEpidemicRegister = (data) => axios.post('company/er/addEpidemicRegister', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });



/**
 * 企业端-历史登记企业复工记录列表
 参数名	必选	类型	说明

 */
let logList = () => axios.get('company/VrCompany/logList');

/**
 * 判断是否已经隔离登记
 参数名	必选	类型	说明
baseInfoId	是	int	基本信息主键ID
 */
let isIsolationRegister = (baseId) => axios.get('company/vr/isRegister?baseInfoId=' + baseId);

/**
 * 根据ID得到详情
 参数名	必选	类型	说明
id	是	int	隔离登记主键ID
 */
let getQuarantine = (id) => axios.get('company/vr/getQuarantine?id=' + id);

/**
 * 新增隔离登记
 */
// let addQuarantin = (data) => axios.post('company/vr/addQuarantine', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

let addQuarantine = (quarantineWay, quarantineStartTime, quarantineDays,quarantinePerson,quarantineDescription,quarantineBaseId) => axios.post('company/vr/addQuarantine', `quarantineWay=${quarantineWay}&quarantineStartTime=${quarantineStartTime}&quarantineDays=${quarantineDays}&quarantinePerson=${quarantinePerson}&quarantineDescription=${quarantineDescription}&quarantineBaseId=${quarantineBaseId}`);

/**
 * 新增隔离登记
 */
// let updateQuarantine = (data) => axios.post('company/vr/updateQuarantine', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
let updateQuarantine = (quarantineId,quarantineWay, quarantineStartTime, quarantineDays,quarantinePerson,quarantineDescription,quarantineBaseId) => axios.post('company/vr/updateQuarantine', `quarantineId=${quarantineId}&quarantineWay=${quarantineWay}&quarantineStartTime=${quarantineStartTime}&quarantineDays=${quarantineDays}&quarantinePerson=${quarantinePerson}&quarantineDescription=${quarantineDescription}&quarantineBaseId=${quarantineBaseId}`);


/**
 * 解除隔离登记
 参数名	必选	类型	说明
id	是	Long	主键id
 */
let deleteQuarantine = (id) => axios.get('company/vr/deleteQuarantine?id=' + id);


/**
 * 企业登记审核列表
 参数名	必选	类型	说明
pageIndex	否	int	pageIndex
pageSize	否	int	pageSize
name	否	string	姓名
 */
let erAuditList = (data) => axios.get('company/erAudit/list', {params: data});

/**
 * 评审接口
 参数名	必选	类型	说明

 */
let erAuditApproval = (data) => axios.post('company/erAudit/approval', JSON.stringify(data), {headers: {'Content-Type': 'application/json'}});

/**
 * 批量列表接口
 参数名	必选	类型	说明

 */
let batchList = () => axios.get('company/erAudit/batchList');

/**
 * 获取二维码图像
参数名	必选	类型	说明
healthCodeContent	是	string	二维码内容
width	是	int	二维码宽度
height	是	int	二维码高度
type	是	int	二维码颜色 1绿 2红 （对应healthCodeType）
 */
// let getImage = (healthCodeContent,width,height,type) => axios.get('company/viral/getImage', {
//   params: {
//     healthCodeContent: healthCodeContent,
//     width: width,
//     height: height,
//     type: type,
//   }
// });


























/**
 * 企业端-历史登记企业复工记录列表
 参数名	必选	类型	说明

 */
let insert = (data) => axios.post('company/VrCompany/insert', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' }});

let detail = (id) => axios.get('company/VrCompany/detail', { params: {id:id} } );



/**
 *是否已上报
 参数名	必选	类型	说明

 */

let reportState = () => axios.get('company/policyDemand/reportState');

/**
 *新增接口
 参数名	必选	类型	说明

 */


let add = (data) => axios.post('company/policyDemand/add', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' }});


/**
 *详情接口
 参数名	必选	类型	说明

 */

let policyDetail = () => axios.get('company/policyDemand/detail');




/**
 *企业人员登记列表口
 参数名	必选	类型	说明
name	是	string	名称
pageIndex	是	int	页码
pageSize	否	int	行数
 */

let viralInfoPersonList = (data) => axios.get('company/viralInfoPerson/list',{params:data});




/**
 *企业人员登记-移除接口
 参数名	必选	类型	说明
cvipId	是	int	主键id
 */

let viralInfoPersonDel = (id) => axios.post(`company/viralInfoPerson/del?cvipId=${id}`);

/**
 *添加企业复工
 参数名	必选	类型	说明

 */


let addReturnWorkApplication = (data) => axios.post('company/returnWork/addReturnWorkApplication',  JSON.stringify(data), { headers: { 'Content-Type': 'application/json' }});


/**
 *添加企业复工
 参数名	必选	类型	说明

 */


let editReturnWorkApplication = (data) => axios.post('company/returnWork/editReturnWorkApplication',  JSON.stringify(data), { headers: { 'Content-Type': 'application/json' }});




/**
 *跳转企业复工人员登记页面
 参数名	必选	类型	说明
cvipId	是	int	主键id
 */

let viralInfoPersonToAdd = (id) => axios.get(`company/viralInfoPerson/toAdd`);
/**
 *企业复工详情
 参数名	必选	类型	说明

 */


let getReturnWorkApplication = (data) => axios.get('company/returnWork/getReturnWorkApplication');





/**
 *企业人员登记-新增登记接口
 参数名	必选	类型	说明
baseIds	是	【】	人员id数组 （例：baseIds=2,62）
 */
let viralInfoPersonAdd = (id) => axios.post(`company/viralInfoPerson/add?baseIds=${id}`);



/**
 *企业人员登记-新增登记接口
 参数名	必选	类型	说明
baseIds	是	【】	人员id数组 （例：baseIds=2,62）
 */
let toAdd = () => axios.get(`/company/VrCompany/toAdd`);

/**
 *行业分类列表
 参数名	必选	类型	说明

 */

let tradeList = () => axios.get('company/returnWork/tradeList');


/**
 *模板列表
 参数名	必选	类型	说明

 */

let templateList = () => axios.get('company/returnWork/templateList');

/**
 * 获取oss配置信息
 *
 */
let getSystemOssByUrl = () => axios.get(`${mainUrl}back/systemOss/systemOssByUrl?url=${ossUrl}`);

/**
 *获取文件类型下拉列表接口
 参数名	必选	类型	说明

 */

let getFileTypeList = () => axios.get('company/fileManage/getFileTypeList');

/**
 *文件管理展示列表接口
 参数名	必选	类型	说明

 */

let getFileManageList = (data) => axios.get('company/fileManage/getFileManageList', { params: data });

/**
 *文件管理展示列表接口
 参数名	必选	类型	说明

 */

let getFileDetail = (data) => axios.get('company/fileManage/getFileDetail', { params: data });

/**
 *获取类型

 */

let getFeedbackTypes = (data) => axios.get('company/feedback/getFeedbackTypes', { params: data });

/**
 * 人员考勤记录列表接口
 */
let getAttendanceRecordList = (params) =>axios.get(`${sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : ''}property/employeeAttendance/getAttendanceRecordList`, {params:params})

/**
 * 获取企业列表接口

 */
let passRecordCompanyList = () =>axios.get(`${sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : ''}property/passRecord/companyList`,)

/**
 * 获取考勤设备列表接口

 */
let attedanceEquipmentDownList = () =>axios.get(`${sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : ''}property/employeeAttendance/attedanceEquipmentDownList`,)

/**
 * 查看考勤设置接口

 */
let getAttendanceSetting = () =>axios.get(`${sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : ''}property/employeeAttendance/getAttendanceSetting`,)

/**
 * 修改考勤设置接口

 */
let updateAttendanceSetting = (params) =>axios.post(`${sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : ''}property/employeeAttendance/updateAttendanceSetting`, params, { headers: { 'Content-Type': 'application/json' } })



/**
 * 企业门户用户导入
 * 参数名	必选	类型	说明
file	是	file	文件
 */

let importUser = (data) => axios.post("/company/user/importUser", data);



/**
pageIndex	是	int
pageSize	是	int
name	否	string	企业名称
twoId	否	int	二级区域id
oneId	否	int	一级区域id
status	否	long	1未响应2未评分3已完成
order	否	long	1 自评降序 2自评升序 3终评升序 4终评降序
 */

export let getList = (data) => axios.get("company/assessmentCompany/getList", { params: data });

/**
评分
 */

export let assessmentscore = (data) => axios.post("company/assessmentCompany/score", JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
企业考核评分详情
assessmentCompanyId	是	long	企业考核详情
 */

export let assessmentdetail = (data) => axios.get("company/assessmentCompany/detail", {params:data});

/**
 *
企业考核字段附件列表

 */

export let assessmentFileList = (data) => axios.get("company/assessmentCompany/fileList", { params: data });

/**
 * 获取redis随机key值接口
 */
let getRandomKey = (data) => axios.get(sessionStorage.getItem('channelMortarBackUrl') + "mortar/face/getRandomKey");

/**
 * 查询上传人脸进度（轮训接口）
 */
let queryFaceProgress = (params) => axios.get(sessionStorage.getItem('channelMortarBackUrl') + "mortar/face/queryFaceProgress", { params: params });


/**
 * 获取房源列表
 */
let getHouseRes = (params) => axios.get("company/mhHouseRes/getHouseRes", { params: params });


/**
 * 场地信息详情
 */
let houseResAreaDetail = (params) => axios.get("company/mhHouseRes/houseResAreaDetail", { params: params });

/**
 * 合同列表
 */
let contractList = (params) => axios.get("company/mhHouseRes/contractList", { params: params });


/**
 * 合同详情
 */
let contractDetail = (params) => axios.get("company/mhHouseRes/contractDetail", { params: params });


/**
 * 账单列表
 */
let billList = (params) => axios.get("company/mhHouseRes/billList", { params: params });

/**
 * 查看电子合同
 */
let fileTemplate = (params) => axios.get("company/mhHouseRes/fileTemplate", { params: params });


/**
 * 票据申请记录列表
 */
let noteGetList = (params) => axios.get("company/note/getList", { params: params });


/*
审批
参数名	必选	类型	说明
*/
let noteAddNote = (data) => axios.post(`/company/note/addNote`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 确认票据申请
 */
let noteSure = (noteId) => axios.post(`company/note/sure?noteId=${noteId}`);

/**
 * 撤回申请
 */
let noteDelNote = (noteId) => axios.post(`company/note/delNote?noteId=${noteId}`);

/**
 * 新增票据申请时所需企业信息
 */
let noteCompanyDetail = (params) => axios.get("company/note/companyDetail", { params: params });

/**
查看票据申请详情
 */
let noteNoteDetail = (params) => axios.get("company/note/noteDetail", { params: params });


/**
判断当前用户是否具有新增票据申请的权限
 */
let noteIsCanAdd = (data) => axios.get(`/company/note/isCanAdd`, { params: data });

/**
用户所属企业下拉接口
 */
let userCompanyList = (data) => axios.get(`/company/mhManager/userCompanyList`, { params: data });

/*
切换企业
参数名	必选	类型	说明
*/
let chooseCompany = (data) => axios.post(`/company/mhManager/chooseCompany`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
企业门户获取合同列表
 */
let getContracts = (data) => axios.get(`/company/mhHouseRes/getContracts`, { params: data });

/**
企业门户获取账单列表
 */
let getBills = (data) => axios.get(`/company/mhHouseRes/getBills`, { params: data });

/**
车位租赁申请列表
 */
let getVehicleApproveList = (data) => axios.get(`/company/parkSpaceApplication/getVehicleApproveList`, { params: data });

/**
车位租赁申请列表
 */
let getVehicleDetail = (data) => axios.get(`/company/parkSpaceApplication/getVehicleDetail`, { params: data });
/*
新增编辑余额提醒详情
参数名	必选	类型	说明
*/
let addBalanceWallet = (data) => axios.post(`/company/balanceDetail/addBalanceWallet`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });


/**
水电余额提醒详情
 */
let getBalanceWallet = (data) => axios.get(`/company/balanceDetail/getBalanceWallet`, { params: data });

/*
新增编辑水电余额提醒联系人
参数名	必选	类型	说明
*/
let addWalletContact = (data) => axios.post(`/company/balanceDetail/addWalletContact`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });


/**
水电余额提醒联系人详情
 */
let getWalletContact = (data) => axios.get(`/company/balanceDetail/getWalletContact`, { params: data });

/**
水电余额提醒联系人列表
 */
let getContactList = (data) => axios.get(`/company/balanceDetail/getContactList`, { params: data });

/**
删除水电余额提醒联系人
 */
let delWalletContact = (data) => axios.get(`/company/balanceDetail/delWalletContact`, { params: data });

/*
新增车位申请
*/
let addVehicleApprove = (data) => axios.post('/company/parkSpaceApplication/addVehicleApprove', stringJoin(data, 2));

/*
删除车位申请
*/
let delVehicleApprove = (vaId) => axios.post(`/company/parkSpaceApplication/delVehicleApprove?vaId=${vaId}`);

/**
获取渠道下所有车场下拉列表
 */
let getAllCarParkGroupList = (data) => axios.get(`/company/parkSpaceApplication/getAllCarParkGroupList`, { params: data });

/**
获取车主下拉列表
 */
let getAllCarOwnerList = (data) => axios.get(`/company/parkSpaceApplication/getAllCarOwnerList`, { params: data });

/*
新增车位申请
*/
let editVehicleApprove = (data) => axios.post('/company/parkSpaceApplication/editVehicleApprove', stringJoin(data, 2));

/*
删除车位申请
*/
let workflowApplicationSure = (workflowApplicationId) => axios.post(`/company/workflowApplication/sure?workflowApplicationId=${workflowApplicationId}`);


/**
 * 操作记录
 */
let operationRecord = (data) => axios.get('/company/safe/recordLog',{params: data})

/**
 * 企业档案信息列表
 */
let companyInfoList = (data) => axios.get('/company/safe/mhList',{params: data})

/**
 * 
 */
let defaultField = () => axios.post('/company/safe/defaultField')

/**
 * 获取工商信息
 */
let getCompanyBusiness = (data) => axios.get('/company/safe/matching',{params: data})

/**
 * 更新企业档案
 */
let updateCompany = (data) => axios.post('/company/safe/update', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })

/**
 * 获取工商信息
 */
let companyInfo = (data) => axios.get('/company/safe/info',{params: data})

/**
 * 获取图形验证码
 */
export let mhManagergCaptcha = () => axios.get(`/company/mhManager/gCaptcha`);


export {
  listNotify, findNotify, changePassword, resourceList, listMatterCompany, findMatterById, handleMatterCompany,
  matterCompanyDetail, editMatterCompany, matterCompanyDetailDetail, getAllType,
  addMatterCompanyFile, listFilesByMatterCompanyId, deleteMatterCompanyFile, indexDate, login, logout, checkLogin,
  sendCode, changeMoblie, getChannelIdByUrl, workflowList, getWorkflow, addWorkflowApplication,
  myWorkflowApplicationList, revocationWorkflowApplication, getWorkflowApplication, companyContractReminds,
  companyBillList, messageList, deleteMessage, getMessage, mhUserList, addMhUser, passMhUser, noPassMhUser,
  addMhRole, findMhRole, updateMhRole, mhRoleList, getPermissions, deleteMhRole, mhManagerList, addMhManager,
  updateMhManager, selectRoleList, deleteMhManager, reSetPassword, getManagerInfo, managerChangePassword,
  managerSendCode, managerChangeMoblie, remindsCount, getManagerByIds, deleteUser, getInfo,
  changeManagerPassword, getVisitor, visitorList, exportVisitorList, serveList, serveDetail,
  feedbackList, addFeedback, feedbackDetail, feedbackDelete, findEntranceByChannel, updateMhUserRole,importUser,
  //人脸
  faceList, passMhUserList, companyAddFace, detailFace, faceRecordList, delPerson, getPersonPassList, systemOssByUrl,

  readConfirm,
  // 疫情
  vrList,vrDetail,

  erList, deleteVR, addEpidemicRegister, logList, insert, detail,isIsolationRegister,addQuarantine,updateQuarantine,getQuarantine,deleteQuarantine,reportState,add,policyDetail,

  // 通行码
  erAuditList,erAuditApproval,batchList,

  // 备案,登记
  viralInfoPersonList,viralInfoPersonDel,viralInfoPersonToAdd,viralInfoPersonAdd,toAdd,
  // 企业复工
  addReturnWorkApplication, getReturnWorkApplication, tradeList, templateList, editReturnWorkApplication, getSystemOssByUrl,

  //获取文件类型下拉
  getFileTypeList, getFileManageList, getFileDetail,

  //获取反馈类型
  getFeedbackTypes,

  //考勤
  getAttendanceRecordList,  passRecordCompanyList, attedanceEquipmentDownList, getAttendanceSetting, updateAttendanceSetting,

  //人脸
  getRandomKey, queryFaceProgress,

  //租赁信息
  getHouseRes, houseResAreaDetail, contractList, contractDetail, billList, fileTemplate,

  //5.1.2
  noteGetList, noteAddNote, noteSure, noteDelNote, noteCompanyDetail, noteNoteDetail, noteIsCanAdd,

  //5.1.4更换登录一对多公司
  sendCodeMsg, userCompanyList, chooseCompany,

  //5.1.5
  getContracts, getBills, getVehicleApproveList, getVehicleDetail, addVehicleApprove, delVehicleApprove, getAllCarParkGroupList, 
  getAllCarOwnerList, editVehicleApprove,
  addBalanceWallet, getBalanceWallet, addWalletContact, getWalletContact, getContactList, delWalletContact,

  //5.1.7
  workflowApplicationSure, operationRecord, companyInfoList, defaultField, getCompanyBusiness, updateCompany, companyInfo

}



// WEBPACK FOOTER //
// ./src/service/getData.js